import * as Sentry from '@sentry/nextjs';
import is from '@sindresorhus/is';

const parseError = (error: unknown): Error => {
  if (is.error(error)) {
    return error;
  }

  if (is.object(error)) {
    return new Error(JSON.stringify(error));
  }

  if (is.string(error)) {
    return new Error(error);
  }

  return new Error('Unknown Error');
};

export const reportToSentry = (error: unknown) => {
  const errorInstance = parseError(error);

  Sentry.captureException(errorInstance);
};
